var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38 28"}},_vm.$listeners),[_c('path',{attrs:{"fill":"none","d":"M2 12.3l11.9 12L36.3 2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }